import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.01 10L2.5 3.49l.99-.99L10 9.01l6.51-6.51.99.99L10.99 10l6.51 6.51-.99.99L10 10.99 3.49 17.5l-.99-.99L9.01 10z" fill="#000" /></svg>;